/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestSmsRequest
 */
export interface TestSmsRequest {
    /**
     * 
     * @type {string}
     * @memberof TestSmsRequest
     */
    phoneNumber: string;
}

/**
 * Check if a given object implements the TestSmsRequest interface.
 */
export function instanceOfTestSmsRequest(value: object): value is TestSmsRequest {
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    return true;
}

export function TestSmsRequestFromJSON(json: any): TestSmsRequest {
    return TestSmsRequestFromJSONTyped(json, false);
}

export function TestSmsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestSmsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phoneNumber': json['phone_number'],
    };
}

export function TestSmsRequestToJSON(json: any): TestSmsRequest {
    return TestSmsRequestToJSONTyped(json, false);
}

export function TestSmsRequestToJSONTyped(value?: TestSmsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone_number': value['phoneNumber'],
    };
}

